import { Container, Grid } from '@mui/material';
import { PageTitle } from '../../utils/pageTitle';
import { NotificationsTable } from '../../sections/@dashboard/notifications';

const tableLabels = [
  { id: 'title', label: 'Título' },
  { id: 'description', label: 'Descrição' },
  { id: 'date', label: 'Data' },
  { id: 'read', label: 'Lida' },
];

export default function StudentNotifications() {
  return (
    <>
      <Container maxWidth="xl">
        <PageTitle area="Aluno" screen="Notificações" />
      </Container>

      <Grid container justifyContent="center" pb={5}>
        <Grid item xs={11} md={6}>
          <NotificationsTable tableLabels={tableLabels} />
        </Grid>
      </Grid>
    </>
  );
}
